// extracted by mini-css-extract-plugin
export var back_top_container = "styles-module--back_top_container--a1723";
export var icon_to_top = "styles-module--icon_to_top--64e16";